import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_landing } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import { getDday } from '../../../../../modules/utils'
import useLandingNav, { checkIsSelected } from '../useLandingNav'

const SubNav = () => {
  const router = useAppRouter()
  const { t } = useTranslation()
  const { promotions } = useLandingNav()

  // 공통적으로 D-Day 계산 로직 처리
  const promotionNavItems = promotions
    .filter((promotion) => promotion.isPublic)
    .map((promotion) => {
      const { label, link, dDay: dDayData } = promotion

      const dDay = dDayData
        ? getDday(
            new Date(
              Date.UTC(dDayData?.target_year, dDayData?.target_month - 1, dDayData?.target_day, dDayData?.target_hour)
            )
          )
        : null
      const shouldShowDDay = dDay !== null && dDay >= 0 && dDay < 8
      const dDayLabel = shouldShowDDay ? (dDay === 0 ? 'D-Day' : `D-${dDay}`) : null

      return {
        title: label,
        link,
        dDay: dDayLabel,
        isShow: true,
      }
    })

  // 기존 메뉴 + 프로모션 메뉴 합치기
  const subNavData = [
    {
      title: n_landing.mo_sub_menu.btn_home,
      link: urls.oneOnOne.index,
      isShow: true,
    },
    ...promotionNavItems,
    {
      title: n_landing.sub_menu_1on1.pricing,
      link: urls.oneOnOne.pricing,
      isShow: true,
    },
    {
      title: n_landing.sub_menu_1on1.list_1,
      link: urls.student.adv.index('1on1/tutor'),
      isShow: true,
    },
    {
      title: n_landing.sub_menu_1on1.list_2,
      link: urls.student.adv.index('1on1/material'),
      isShow: true,
    },
  ]

  const handleLinkClick = (link: string) => {
    router.push(link)
  }

  return (
    <nav className="px-14 h-[44px] w-full flex gap-x-10 bg-white/90 overflow-x-auto whitespace-nowrap no-scrollbar">
      {subNavData.map((nav, index) => {
        if (!nav.isShow) return null
        return (
          <button
            key={index}
            className={`p-8 ${checkIsSelected(router, nav.link) ? 'text-purple-600 border-b border-purple-600' : ''}`}
            onClick={() => handleLinkClick(nav.link)}
          >
            <div className="flex gap-x-4 items-center">
              <span className="Body2-14Md">{t(nav.title)}</span>
              {nav.dDay && <span className="px-6 Caption-12Bd bg-red-500 text-white rounded">{nav.dDay}</span>}
            </div>
          </button>
        )
      })}
    </nav>
  )
}

export default SubNav
